import { useNavigate, useLocation, Navigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from 'react';
import { Helmet } from "react-helmet";
import Header from '../body_root/header';
import Footers from '../body_root/footer';
import Navbar from '../body_root/Navbar';
import './rent.css';
import { Toast } from '../components_root/ToastContext';
import { MdLocationCity } from "react-icons/md";
export const seo = {
    title: "Viabig Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    description: "Discover Viabig's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more. Enhance productivity with powerful tools for students, writers, developers, and businesses.",
    keywords: "viabig services, free online tools, premium tools, seo tools, text utilities, file converters, image to pdf, favicon generator, word counter, productivity tools, online converters",
    url: "https://viabig.com/rent",
    image: "https://viabig.com/assets/logo.png"
};
export default function Rent_root() {
    const [text, setText] = useState("");
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    return (
        <div>
            <Header />
            <Helmet>
                <title>{seo.title}</title>
                <meta name="description" content={seo.description} />
                <meta name="keywords" content={seo.keywords} />
                <meta property="og:title" content={seo.title} />
                <meta property="og:description" content={seo.description} />
                <meta property="og:image" content={seo.image} />
                <meta property="og:url" content={seo.url} />
            </Helmet>

            <div className="container_roots">
              
                <div className="container_size p-3">
                    <h2 className="text-xl font-bold mb-4">Rent</h2>
                    <div className='post-container'>

                       
                    </div>

                </div>
            </div>

            <Footers />
            <Navbar />
        </div>
    );
}
